import { render, staticRenderFns } from "./ContactManageView.vue?vue&type=template&id=4606d7e2&scoped=true&"
import script from "./ContactManageView.vue?vue&type=script&lang=js&"
export * from "./ContactManageView.vue?vue&type=script&lang=js&"
import style0 from "./ContactManageView.vue?vue&type=style&index=0&id=4606d7e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4606d7e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4606d7e2')) {
      api.createRecord('4606d7e2', component.options)
    } else {
      api.reload('4606d7e2', component.options)
    }
    module.hot.accept("./ContactManageView.vue?vue&type=template&id=4606d7e2&scoped=true&", function () {
      api.rerender('4606d7e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/contacts/pages/ContactManageView.vue"
export default component.exports